<template>
  <div id="g-page" >  
    <table border="0" id="main-table-screen" >
      <tr>
        <td id="main-table-row1" colspan="3"> 
        </td>
      </tr>

      <tr>
        <td style="width:5%"></td>
        <td id="main-table-row2-dialog-container-td">
          <table border="0" style="width:100%" class="dialog-table-radius">
            <tr>
              <td id="dialog-invite" align="center" colspan="2">
                <table border="0">
                  <td id="dialog-invite-title">
                    <!-- Manage Invites-->
                    {{ $t('invite.title') }}
                  </td>
                </table>
              </td>            
            </tr>
            <tr>
              <td id="dialog-instructions" colspan="2">
                <!--Instructions:  -->
                <!--One or more physician(s) have invited you to become their patient. Please select an invite from the list to accept or decline.-->
                {{ $t('invite.instructions') }}
              </td>
            </tr>
            <tr>
              <td class="dialog-body" colspan="1" >
                <div id="scrollable-table">
                  <table border="0" style="width:100%">
                    <thead>
                      <tr id="table-header" class="border-dots">
                        <th class="dialog-body-header">
                          <!--Physician-->
                          {{ $t('invite.headerPhysician') }}
                          </th>
                        <th class="dialog-body-header">
                          <!--Invite On-->
                          {{ $t('invite.headerInviteOn') }}
                          </th>
                        <th class="dialog-body-header">
                          <!--Select Invite<-->
                          {{ $t('invite.headerSelect') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <div v-if="this.invites.length == 0"> 
                        <tr>
                          <td colspan="3">
                            <!--You currently have no invites.-->
                            {{ $t('invite.noInvites') }}
                          </td>
                        </tr>
                      </div>
                      
                      <tr v-for="item in this.invites" :key="item.inviteId" class="border-dots">
                        <td class="dialog-body-data result-col-width-name">
                          {{ item.sourceUser }}
                        </td>                      
                        <td class="dialog-body-data result-col-width-date"> 
                          {{ formatDate(item.timeStamp) }}
                        </td>
                          <td id="dialog-input-field-accept-decline">
                            <input type="button" class="dialog-input-button" :name="'cmdAccept' + item.inviteId" v-on:click="accept(item.inviteId)" v-bind:value="$t('invite.accept')" >
                            <input type="button" class="dialog-input-button" :name="'cmdDecline' + item.inviteId" v-on:click="decline(item.inviteId)" v-bind:value="$t('invite.decline')">
                            <!--
                            <input type="checkbox" 
                            :name="'chkInvite' + item.inviteId"
                            v-model="invites[getIndex(invites, item.inviteId)].value"
                            v-on:click="onCheck(getIndex(invites, item.inviteId), $event)">-->
                        </td>
                      </tr>
                      
                    </tbody>
                  </table>     
                </div>           
              </td> 
            </tr>
            <tr>
              <td id="dialog-input-field-finished" colspan="2">  
                <input type="button" class="dialog-input-button" v-on:click="finished" v-bind:value="$t('invite.finished')">
              </td>
            </tr>
          </table>

        </td>
        <td  style="width:5%"></td>
      </tr>
      <tr>
        <td id="main-table-row3" colspan="3" > 
        </td>
      </tr>
    </table>
  </div>
</template>

<script>

import messageBox from './../common/message-box'
//import moment from 'moment'
const { DATE_SUPPORT } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )
const { API } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )
const { SUPPORT } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

export default {
  name: 'member-invites',
  data() {
      return {
          invites: [],
          inviteLength:0,
          isProcessing:false
      }
  },
  methods: {
    /* formatDate (d)
    {
      return moment(d).format('YYYY-MM-DD') 
    }, */
    formatDate (d)
    {
      return DATE_SUPPORT.formatDate(d);
    },
    load()
    {
      try
      {
        SUPPORT.showServiceMenus();

        
        API.readInvite(window.sessionKey, this.$i18n.locale)
        .then(response => {
          if(response.data.hasError == true)
          {
            this.isProcessing = false;
            this.$generalMessage(messageBox, response.data.errorMessage);
            SUPPORT.securityCheck(response.data.errorId);
          }
          else
          {
            this.invites = response.data.invites;
            this.inviteLength = response.data.length;           
          } 
        }).catch( e =>
        {
          this.$generalMessage( messageBox, e );            
        })
      }
      catch(e)
      {
        this.$generalMessage( messageBox, e );
      } 
    },
    /*formatDate(d)
    {
      return moment(d).format('YYYY-MM-DD') 
    }, */
    accept(id)
    {
      API.updateInvite(window.sessionKey, 
                        id, //item.inviteId,
                        1, // ACCEPT
                        this.$i18n.locale)
      .then(response => {
        if(response.data.hasError == true)
        {
          this.isProcessing = false;
          this.$generalMessage(messageBox, response.data.errorMessage);
          SUPPORT.securityCheck(response.data.errorId);
        }
        else
        {
          this.invites = response.data.invites;
          this.inviteLength = response.data.length;
          // "The invite for " + name + " was successfully accepted."
          var msg = this.$t('invite.msgAccepted1') + " " + name + " " + this.$t('invite.msgAccepted2');
          this.$generalMessage( messageBox, msg );
        } 
      }).catch( e =>
      {
        this.$generalMessage( messageBox, e );            
      })
    },
    decline(id) 
    {
    
      API.updateInvite(window.sessionKey, 
                        id, //item.inviteId,
                        0, // DECLINE
                        this.$i18n.locale)
      .then(response => {
        if(response.data.hasError == true)
        {
          this.isProcessing = false;
          this.$generalMessage(messageBox, response.data.errorMessage);
          SUPPORT.securityCheck(response.data.errorId);
        }
        else
        {
          this.invites = response.data.invites;
          this.inviteLength = response.data.length;
          // "The invite for " + name + " was successfully declined."
          var msg = this.$t('invite.msgDeclined1') + " " + name + " " + this.$t('invite.msgDeclined2');
          this.$generalMessage( messageBox, msg );
        } 
      }).catch( e =>
      {
        this.$generalMessage( messageBox, e );            
      })
    },
    finished()
    {
      if(this.invites.length > 0)
      {
        // "You must Accept or Decline all Invites to continue."
        this.$generalMessage(messageBox, this.$t('invite.toContinue'));
        return;
      }

      //this.$router.push( { path: "/members/c19-daily-questionnaire"} );
      if(window.defaultDailyQuestionnaireTypeId == 1) // COVID
      {
        this.$router.push( { path: "/members/c19-daily-questionnaire"} );
      }
      else if(window.defaultDailyQuestionnaireTypeId == 2) // FIT FOR DUTY
      {
        this.$router.push( { path: "/members/daily-questionnaire"} );
      }
      else if(window.defaultDailyQuestionnaireTypeId == 3)  // DASHBOARD
      {
        this.$router.push( { path: "/members/dashboard"} );
      }
      this.isProcessing = false;
    },
  },
  mounted () {
    // SHOW TOP OF VIEW
    window.scrollTo(0, 0);
    
    this.load();
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/global.css";

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  // BEGIN SIGNON DIALOG STYLES
  #main-table-screen
  {
    background-color:gray;
    padding: 0px;
    margin: 0px;
    width:100%;
    margin-bottom:0px;
    display:table;
    max-width:100%;
    min-width:100%;
  }
  #main-table-row1
  {
    height:32px; 
  }
  #main-table-row2-dialog-container-td
  {
    width:95%;
    padding-left: 5%;
  }
  .dialog-table-radius
  {
    border-radius: 15px !important;
    overflow:hidden;
  }
  #dialog-invite
  {
    height:55px;
    background-color:#4682B4;
    color:white;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  #dialog-invite-title
  {
    vertical-align:bottom;
    text-align: center;
    padding-top:10px;
    padding-bottom:10px;
    font-family:'Arial Black';
    font-size: 22pt;
    font-weight: 600;
  }
  #dialog-instructions
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: justify;
    padding-top:15px;
    padding-left:15px;
    padding-right:15px;
    padding-bottom:0px;
  }
  .dialog-body
  {
    color:white;
    background-color:#343F68;
    padding:15px;
  }
  .dialog-body-data
  {
    color:white;
    background-color:#343F68;
    text-align: justify;
    font-family:'Lato';
  }
  .dialog-body-header
  {
    color:white;
    background-color:#343F68;
    text-align: justify;
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: center;
    font-weight:700;
  }
  .border-dots
  {
    //border-bottom-style:none;
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:#4682B4 !important;
  }
  #table-header
  {
    display:none;
  }
  #dialog-input-field-finished
  {
    height:30px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    padding-right:8px;
    padding-bottom:50px;
  }  
  .dialog-input-button
  {
    color:white;
    height:35px;
    background-image: linear-gradient(#4682B4,#4682B4); // STRANGE MOBILE INHERITANCE SHIT
    vertical-align: middle !important; 
  }
  #main-table-row3
  {
    height:60px;
  }
  .result-col-width-name
  {
    width:100%;
  }
  .result-col-width-date
  {
    width:100%;
  }
  .result-col-width-check
  {
    width:100%;
  }
  #dialog-input-field-accept-decline
  {
    color:white;
    background-color:#343F68;
    width:100%;
    padding-bottom: 10px;
    padding-top: 10px;
  }
  #scrollable-table
  {
    height:200px;
    overflow-y:auto;
    border:solid;
    border-width: 1px;
    border-color: #4682B4;
  }
  // END SIGNON DIALOG STYLES
}

//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  // BEGIN SIGNON DIALOG STYLES
  #main-table-screen
  {
    background-color:gray;
    padding: 0px;
    margin: 0px;
    width:100%;
    margin-bottom:0px;
    display:table;
    max-width:100%;
    min-width:100%;
  }
  #main-table-row1
  {
    height:85px; 
  }
  #main-table-row2-dialog-container-td
  {
    width:90%;
  }
  .dialog-table-radius
  {
    border-radius: 15px !important;
    overflow:hidden;
  }
  #dialog-invite
  {
    height:40px;
    width:300px;
    background-color:#4682B4;
    color:white;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  #dialog-invite-title
  {
    vertical-align:bottom;
    padding-top:10px;
    padding-bottom:10px;
    font-family:'Lato';
    font-size: 22pt;
    font-weight: 600;
  }
  #dialog-instructions
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: justify;
    padding-top:15px;
    padding-left:25px;
    padding-right:25px;
    padding-bottom:0px;
  }
  .dialog-body
  {
    color:white;
    background-color:#343F68;
    text-align: justify;
    padding:25px;
  }
  .dialog-body-data
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: center;
    padding-left:40px;
    padding-right:40px;
  }
  .dialog-body-header
  {
    font-family:'Lato';
    color:white;
    background-color:#343F68;
    text-align: center;
  }
  .border-dots
  {  
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:#4682B4 !important;
  } 
  #table-header
  {
    display:visible;
  }
  #dialog-input-field-finished
  {
    height:50px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:8px;
  }
  .dialog-input-button
  {
    width:90px;
    color:white;
    background-color:#4682B4 ;   
    vertical-align: middle !important;
  }
  #main-table-row3
  {
    height:250px;
  }
  .result-col-width-name
  {
    width:40%;
  }
  .result-col-width-date
  {
    width:40%;
  }
  .result-col-width-check
  {
    width:empty;
  }
  #dialog-input-field-accept-decline
  {
    color:white;
    background-color:#343F68;
    min-width: 150px;
    width:150px;
    max-width: 150px;
    vertical-align: middle;
    text-align: center;
  }
  #scrollable-table
  {
    height:200px;
    overflow-y:auto;
  }
  // END SIGNON DIALOG STYLES
}
</style>